import React from 'react';
import { Link } from 'react-router-dom';
import './Historia.css';

function Historia() {
    return (
        <section className="historia-seccion">
            <title>Historia | DanPauleX</title>
            <link rel="canonical" href="https://danpaulex.com/historia" />
            <meta
                name="description"
                content="DanPaulex surge de la alianza entre dos emprendedores con una sólida trayectoria en el sector logístico para brindar soluciones logísticas eficientes con una atención cercana y personalizada."
            />

            <div className="historia-contenedor">
                <div className="historia-texto">
                    <h1>Historia de DanPaulex</h1>
                    <p>
                        En DanPaulex contamos con una historia breve, pero con una visión clara y un gran futuro por delante.
                        <br /><br />
                        La empresa surge de la alianza entre dos emprendedores con una sólida trayectoria en el sector logístico,
                        decididos a unir sus fortalezas para ofrecer una mayor capacidad operativa, sin renunciar a la calidad,
                        el compromiso y la profesionalidad que nos definen.
                        <br /><br />
                        Nuestro propósito es claro: brindar soluciones logísticas eficientes, adaptadas a las exigencias del mercado
                        actual y respaldadas por una atención cercana y personalizada.
                    </p>
                    <Link to="/contacto" className="historia-boton">Contáctanos</Link>
                </div>
                <div className="historia-imagen">
                    <img
                        src="/images/Historia.webp"
                        alt="Un camión y una furgoneta de DanPaulex con el logotipo DPX Operador de transportes"
                        width="1000"
                        height="750"
                        decoding="async"
                    />
                </div>
            </div>
        </section>
    );
}

export default Historia;
